import { SVGProps } from 'react';

const ArrowsUpFromLine = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10 6 7 3 4 6m3-3v14M20 6l-3-3-3 3m3-3v14M4 21h16"
    />
  </svg>
);
export default ArrowsUpFromLine;
